/**
 * Token grafici del Task Radar (task-radar/app/lib/theme/tokens.dart, tema
 * chiaro) per gli stili inline. Le classi Tailwind slate/gray sono già
 * rimappate su questi toni in index.css; qui servono dove il colore va scritto
 * a mano (stili inline, grafici, toast).
 */
export const T = {
  bg: '#FAFAFB',          // pagina
  sunken: '#F4F5F7',      // menù e superfici incassate, un passo sotto la pagina
  surface: '#FFFFFF',     // card e pannelli
  surfaceHigh: '#F0F1F4', // hover e righe selezionate
  border: '#DDE0E6',
  borderSoft: '#EBEDF1',
  ink: '#13161C',
  inkMuted: '#5B6270',
  inkFaint: '#8B92A0',
  accent: '#FDF751',      // giallo ByMarke: solo riempimento, sopra c'è testo nero
  onAccent: '#13161C',
  danger: '#DC2626',
  success: '#16A34A',
  warning: '#B45309',
  info: '#2563EB',
} as const;

export const FONT_SANS = "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";
export const FONT_SERIF = "'Libre Baskerville', Georgia, 'Times New Roman', serif";

/** Fade.fast del Radar: 130ms easeOutCubic, per colori e opacità. */
export const EASE_OUT = 'cubic-bezier(0.33, 1, 0.68, 1)';
export const FADE_FAST = `130ms ${EASE_OUT}`;

/**
 * Molle del Radar (motor: CupertinoMotion). `panel` = smooth (500ms, senza
 * rimbalzo) per pannelli e larghezze; `press` = snappy (500ms, rimbalzo 0.15)
 * per la pressione. Da passare a framer-motion come `transition`.
 */
export const SPRING_PANEL = { type: 'spring', duration: 0.5, bounce: 0 } as const;
export const SPRING_PRESS = { type: 'spring', duration: 0.5, bounce: 0.15 } as const;
